import Carousel from "./Carousel";
import HomePageComp from "./HomePageComp";
import GoToTop from "../utils/gotoTop";
const Body = () => {
  return (
    <>
      <Carousel />
      <HomePageComp />
      <GoToTop />
    </>
  );
};
export default Body;
